<template>
<div>
    <div class="main">
        <div class="content-container">
            <div class="content-wrapper">
              <div class="content-banner-box">
                <div class="banner-box">
                  <div class="banner-box-title">一站式出行行业数字化解决方案服务商</div>
                </div>
              </div>
              <div class="form_box"> 
                <div class="content-box">
                    <div class="content-tab content-tab-title">
                        账号注册
                    </div>
                    <template>
                        <form class="form-container" :ref="formDataRef">
                            <div class="form-container-item">
                                <div class="item-content item_content_mg_lf">
                                  <!-- <label class="item-label" style="width: 140px">用户名：</label> -->
                                  <div class="item-input-box">
                                    <input v-model="formData.username" maxlength="20" type="text" prop="username" placeholder="请输入用户名" :class="{'errorRules': modelControl['username']}"  class="input__inner" >
                                    <div class="error-message" v-if="modelControl['username']">{{modelControl['username']}} </div>
                                  </div>
                                </div>
                            </div>
                            <div class="form-container-item">
                                <div class="item-content item_content_mg_lf">
                                  <!-- <label class="item-label" style="width: 140px">昵称：</label> -->
                                  <div class="item-input-box">
                                    <input v-model="formData.name" maxlength="8" type="text" prop="name" placeholder="请输入昵称" :class="{'errorRules': modelControl['name']}"  class="input__inner" >
                                    <div class="error-message" v-if="modelControl['name']">{{modelControl['name']}} </div>
                                  </div>
                                </div>
                            </div>
                            <div class="form-container-item">
                                <div class="item-content item_content_mg_lf">
                                <!-- <label class="item-label" style="width: 140px">手机号：</label> -->
                                  <div class="item-input-box">
                                    <input v-model="formData.phone" maxlength="11" type="text" prop="phone" placeholder="请输入手机号" :class="{'errorRules': modelControl['phone']}"  class="input__inner">
                                    <div class="error-message" v-if="modelControl['phone']">{{modelControl['phone']}} </div>
                                  </div>
                                </div>
                            </div>
                            <div class="form-container-item">
                                <div class="item-content item_content_mg_lf">
                                <!-- <label class="item-label" style="width: 140px">验证码：</label> -->
                                  <div class="item-input-box">
                                    <div class="flex-between">
                                      <input v-model="formData.code" maxlength="6" type="text" prop="code" placeholder="请输入验证码" :class="{'errorRules': modelControl['code']}" class="input__inner">
                                      <button class=" getcode-button" :class="{'isSendCodeActive': isSendCodeActive}" @click.prevent ="handleGetCode" :disabled="isSendCodeActive">{{sendCodeText}}</button>
                                    </div>
                                    <div class="error-message" v-if="modelControl['code']">{{modelControl['code']}} </div>
                                  </div>
                                </div>
                            </div>
                            <div class="form-container-item">
                                <div class="item-content item_content_mg_lf">
                                  <!-- <label class="item-label" style="width: 140px">新密码：</label> -->
                                  <div class="item-input-box">
                                    <input v-model="formData.password" maxlength="20" type="password" prop="password"  placeholder="设置密码" :class="{'errorRules': modelControl['password']}" class="input__inner" >
                                    <div class="error-message" v-if="modelControl['password']">{{modelControl['password']}} </div>
                                  </div>
                                </div>
                            </div>
                            <div class="form-container-item">
                                <div class="item-content item_content_mg_lf">
                                <!-- <label class="item-label" style="width: 140px">确认密码：</label> -->
                                  <div class="item-input-box">
                                    <input v-model="formData.password2" maxlength="20" type="password" prop="password2"  placeholder="再次输入密码" :class="{'errorRules': modelControl['password2']}" class="input__inner" >
                                    <div class="error-message" v-if="modelControl['password2']">{{modelControl['password2']}} </div>
                                  </div>
                                </div>
                            </div>
                            <div class="footer-agreement">
                                <span>
                                    <input type="radio" v-model="formData.agreement" :value="1" />阅读并同意平台"<router-link to="/serviceAgreement" class="aLinkblue">服务协议</router-link>"、"<router-link to="/privacyAgreement" class="aLinkblue">隐私协议</router-link>"
                                </span>
                            </div>
                        </form>
                    </template>

                    <div class="form-container-item">
                        <div class="item-content item_content_mg_lf">
                        <!-- <label class="item-label" style="width: 140px"></label> -->
                            <button class="form-button margin-bt15" @click="handleRegister">注册</button>
                        </div>
                    </div>
                    <div class="form-container-item">
                        <div class="item-content item_content_mg_lf">
                        <!-- <label class="item-label" style="width: 140px"></label> -->
                          <div class="login-footer-container margin-tp-bt15 ">
                              <div class="flex-between ">
                                  <div>已有账号？ <router-link to="/login" class="aLinkblue">去登录</router-link>
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
  userRegister,
  userRegisterSendCode
} from '@/api/api'
import { mapState, mapActions } from 'vuex'
import Schema from 'async-validator'
export default {
  data () {
    return {
      isErr: false,
      isSuccess: false,
      isSubmit: true,
      formData: {
        phone: '',
        agreement: 1,
        password: '',
        password2: '',
        code: '',
        username: '',
        name: ''
      },
      isActive: 1,
      sendCodeText: '获取验证码',
      isSendCodeActive: false,

      rules: {
        username: [
          { required: true, message: '请输入用户名' },
          { required: true, pattern: /^[a-zA-Z0-9]{6,20}$/, min: 6, max: 20, message: '长度为6~20位, 可以使用数字、大小写字母', }
        ],
        name: [
          { required: true, message: '请输入昵称' },
          { required: true, min: 2, max: 8, message: '长度为2~8'}
        ],
        phone: [
          { required: true, message: '请输入手机号' },
          { required: true, pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }
        ],
        password: [
          { required: true, message: '请输入密码' },
          { required: true, pattern: /([=.*^a-zA-Z0-9]){6,20}/, min: 6, max: 20, message: '长度为6~20位，可以使用数字、大小写字母、特殊字符', trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '请输入密码' },
          { required: true, pattern: /([=.*^a-zA-Z0-9]){6,20}/, min: 6, max: 20, message: '长度为6~20位，可以使用数字、大小写字母、特殊字符', trigger: 'blur' }
        ],
        code: [
          { required: true, pattern: /^\d{6}$/, message: '请输入验证码' }
        ]
      },
      formDataRef: 'formDataRef',
      modelControl: {},
      formError: {}
    }
  },
  methods: {
    ...mapActions(['sendCode']),
    handleTab (val) {
      this.isActive = val
    },
    handleGetCode () {
      if (!this.formData.phone) return
      let data = {
        phone: this.formData.phone
      }
      let _this = this
      this.sendCode(data).then(res => {
        if (!res) {
          this.$toast({
            title: "成功",
            content: "发送成功",
            type: "success",
          });
          this.isSendCodeActive = true
          let num = 60
          let timer = null
          let sendCodeText = '60S'
          timer = setInterval(() => {
            if (num === 0) {
              clearInterval(timer)
              _this.sendCodeText = '获取验证码'
              _this.isSendCodeActive = false
            } else {
              num--
              sendCodeText = `${num}S`
              _this.sendCodeText = sendCodeText
            }
          }, 1000)
        }
      }).catch(err => {
        this.isSendCodeActive = false
      })
    },
    handleRegister () {
      console.log(this.formData)
      // let fieldsArr = []
      // let newfields = {}
      // for(let key1 of this.$refs[this.formDataRef]) {
      //     let attributesArr =  key1.getAttribute("prop")
      //     fieldsArr.push(attributesArr)
      // }
      // fieldsArr.forEach(el => {
      //   if (this.rules[el]) {
      //     newfields[el] = this.rules[el]
      //   }
      // });
      // this.validator = new Schema(newfields)
      // let errors = this.validator.validate(this.formData).then((value) => {
      //   // 校验通过
      //       this.modelControl = {}
      // }).catch(({ errors, fields }) => {
      //     console.log(errors);
      //       let modelControl ={}
      //     for(let key in fields) {
      //         modelControl[key] = fields[key][0].message
      //     }
      //     this.modelControl = modelControl
      //     return errors
      // })

      let errors = this.rulesFunc(this.formDataRef, this.formData, this.rules)
      console.log(errors)
      errors.then((v) => {
        if (!v) {
          // console.log('通过')
          // console.log(this.formData)
          if (this.formData.password !== this.formData.password2) {
            // this.$message.warning('两次密码不一致,请重新输入')
            this.$toast({
              // title: "提示",
              content: "两次密码不一致,请重新输入",
              type: "warning",
            });
            return
          }
          let data = Object.assign({}, this.formData)
          data.password2 = ''
          userRegister(data).then(res => {
            if (res.status == 200) {
              // this.$message.success('注册成功')
              
              this.$toast({
                // title: "提示",
                content: "注册成功",
                type: "success",
              });
              this.formData = {
                phone: '',
                agreement: 1,
                password: '',
                password2: '',
                code: '',
                username: '',
                name: ''
              }
              this.isSendCodeActive = false
              this.$router.push({
                path: '/login'
              })
            }
          })
        } else {
          console.log('不通过')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    handleBlurRules (e) {
      console.log(e)
      const prop = e.target.attributes.prop.value
      if (!prop) {
        return false
      }
      this.rulesFunc(this.formDataRef, this.formData, this.rules)
    },
    rulesFunc (formDataRef, formData, rules) {
      let fieldsArr = []
      let newfields = {}
      for (let key1 of this.$refs[formDataRef]) {
        let attributesArr = key1.getAttribute('prop')
        fieldsArr.push(attributesArr)
      }
      fieldsArr.forEach(el => {
        if (this.rules[el]) {
          newfields[el] = rules[el]
        }
      })
      this.validator = new Schema(newfields)
      let errors = this.validator.validate(formData).then((value) => {
        // 校验通过
        this.modelControl = {}
      }).catch(({ errors, fields }) => {
        // this.modelControl[prop] = fields[prop][0].message;
        let modelControl = {}
        for (let key in fields) {
          modelControl[key] = fields[key][0].message
        }
        this.modelControl = modelControl
        return errors
      })
      return errors
    }

  }
}
</script>

<style scoped lang="scss">
/* 登录注册内容样式 */
// .main {
//   width: 100%;
//   height: 100%;
//   background-color: #fff;
// }

// .content-container {
//   min-height: calc(100vh - 150px);
//   box-sizing: border-box;
//   margin: 0 auto;
//   /* padding: 0 30px; */
// }

// .content-wrapper {
//   width: 100%;
//   height: 100%;
//   display: inline-flex;
//   /* align-items: center; */
//   /* flex-direction: column; */
//   justify-content: flex-start;
// }
// .form_box {
//   width: 63.5417rem;
//   height: 100vh;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// .content-box {
//   padding: $fontSize45;
//   /* border-radius: 5px; */
//   background-color: #fff;
//   box-sizing: border-box;
// }
// .content-banner-box {
//   width: 36.4583rem;
//   height: 100vh;
//   margin: 0;
//   padding: 0;
// }
// .banner-box {
//   width: 100%;
//   height: 100%;
//   background-image: url("~@/assets/images/login_bg.png");
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position-x: center;

// }
// .banner-box-title {
//   color: #333333;
//   font-family: PingFang SC;
//   font-size: $fontSize32;
//   font-weight: 500;
//   line-height: $fontSize46;
//   text-align: center;
//   padding-top: 3.6458rem;
//   box-sizing: border-box;
//   margin: auto;
// }
// .content-tab {
//   font-weight: 400;
//   font-style: normal;
//   font-family: PingFang SC;
//   font-size: $fontSize32;
//   color: #333;
//   margin: 0 auto $fontSize32;
//   width: 22.9167rem;
// }

// .content-tab > div {
//   display: inline-block;
//   // padding: $fontSize15 0px;
//   // margin-right: 20px;
//   padding: $fontSize16 0;
//   margin-right: $fontSize20;
//   box-sizing: border-box;
//   cursor: pointer;
// }

// .content-tab .is-active {
//   color: #0069EA;
//   border-bottom: $fontSize4 solid #0069EA;
// }

// .form-container {
//   padding: $fontSize16 0;
//   box-sizing: border-box;
//   font-weight: 400;
//   font-style: normal;
//   font-size: $fontSize18;
//   // font-size: 18px;
// }

// .form-container-item {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-bottom: $fontSize20;
//   // margin-bottom: 18px;
// }

// .item-content > .item-label,
// .form-container-item > .item-content {
//   line-height: $fontSize46;
// }

// .form-container-item > .item-content {
//   /* position: relative; */
//   // display: flex;
//   width: 22.9167rem;
//   // width: 440px;
// }
// .item-content > .item-label {
//   /* position: absolute;
//   left: 0; */
//   float: left;
//   text-align: right;
//   padding: 0 $fontSize12 0 0;
//   box-sizing: border-box;
//   color: #666666;
//   flex: 1;
// }

// .item-input-box {
//   position: relative;
// }
// .input__inner {
//   background-color: #fff;
//   background-image: none;
//   border-radius: $fontSize4;
//   border: $fontSize1 solid #dcdfe6;
//   box-sizing: border-box;
//   color: #333;
//   display: inline-block;
//   // height: 50px;
//   // line-height: 50px;
//   // padding: 0 $fontSize15;
//   height: $fontSize46;
//   line-height: $fontSize46;
//   padding: 0 $fontSize16;
//   outline: 0;
//   width: 100%;
//   box-sizing: border-box;
//   font-size: inherit;
// }
// .input__inner.errorRules {
//   border: $fontSize1 solid red;
// }
// .input__inner::input-placeholder {
//   color: #C0C4CC;
// }
// .error-message {
//   position: absolute;
//   left: 0;
//   top: 100%;
//   padding-top: $fontSize2;
//   font-size: $fontSize12;
//   color: red;
//   line-height: 1;
// }
// .form-button {
//   display: inline-block;
//   width: 100%;
//   font-size: $fontSize20;
//   border-radius: $fontSize4;
//   color: #fff;
//   background-color: #0069EA;
//   line-height: 1;
//   white-space: nowrap;
//   cursor: pointer;
//   border: $fontSize1 solid #0069EA;
//   box-sizing: border-box;
//   outline: 0;
//   margin: 0;
//   transition: 0.1s;
//   font-weight: 500;
//   padding: $fontSize12 $fontSize20;
//   flex: 3;
// }
// .margin-bt15 {
//   margin-bottom: $fontSize15;
// }

// .margin-lf40 {
//   margin-left: 40px;
// }

// .margin-tp-bt15 {
//   margin-top: $fontSize15;
//   margin-bottom: $fontSize15;
// }

// .login-footer-container {
//   font-size: $fontSize20;
//   margin-bottom: $fontSize46;
//   flex: 3;
// }

// .flex-between {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }

// .aLinkblue {
//   color: #0069EA;
//   text-decoration: none;
//   cursor: pointer;
// }
// .position_relative {
//   position: relative;
// }
// .getcode-button {
//   position: absolute;
//   right: 0;
//   top: 0;
//   white-space: nowrap;
//   height: $fontSize46;
//   line-height: 100%;
//   cursor: pointer;
//   border: none;
//   border-radius: 0 $fontSize4 $fontSize4 0;
//   // padding: 16px 27px;
//   box-sizing: border-box;
//   outline: 0;
//   transition: 0.1s;
//   font-weight: 500;
//   background-color: #0069EA;
//   color: #fff;
//   width: 8.3333rem;
//   font-size: $fontSize20;
// }

// .getcode-button.isSendCodeActive {
//   background: #cccccc;
// }
// .text-center {
//   text-align: center;
// }

// .fs20 {
//   font-size: $fontSize20;
// }
// .footer-agreement {
//   font-size: $fontSize18;
//   // margin-left: 140px;
// }
// .item_label_wd {
//   /* width: 100%;
//   max-width: 20%; */
// }
// .item_content_mg_lf {
//   /* padding-left: 20%; */
// }

// @media screen and (min-width: 300px) and (max-width: 768px) {
  
//   .content-container {
//     min-height: calc(100vh - 100px);
//     display: flex;
//     align-items: center;
//     justify-content: center;  
//   }
//   .content-banner-box {
//     transition: all 0.3s;
//     display: none;
//   }
//   .content-box {
//     padding-top: 8rem;
//   }
//   .content-tab .is-active {
//     border-bottom: 2px solid #0069EA;
//   }
//   .form_box {
//     width: 100%;
//     // height: calc(100vh - 21.3333rem);
//     height: 100%;  
//     transition: all 0.3s;

//   }
//   .content-tab {
//     font-weight: 400;
//     font-style: normal;
//     font-family: PingFang SC;
//     font-size: 4.8rem;
//     color: #333;
//     margin: 0 auto 8rem;
//     width: 82.9333rem;
//     // height: 40px;
//   }
//   .form-container-item > .item-content {
//     width: 82.9333rem;
//   }
//   .form-container {
//     padding: 4.2667rem 0;
//     font-size: 3.7333rem;
// }
// .form-container-item{
//     margin-bottom: 5rem;
// }
// .input__inner{
//     border-radius: 1.0667rem;
//     border: 1px solid #dcdfe6;
//     height: 10.6667rem;
//     line-height: 10.6667rem;
//     padding: 0 3.2rem;
//     width: 100%;
//     font-size: inherit;
// }
// .input__inner.errorRules{
//     border: 1px solid red !important;
// }
// .error-message {
//     padding-top: .2667rem;
//     font-size: 2.4rem;
// }
// .item-content > .item-label, .form-container-item > .item-content{
//     line-height: 10.6667rem;
// }
//   .form-button{
//     border-radius: 1.0667rem;
//     border: 1px solid #0069EA;
//     padding: 2.8rem;
//     font-size: 3.7333rem;
//     font-weight: 400;
//     line-height: 5.6rem;
// }
// .content-tab > div {
//   margin-right: 4.2667rem;
// }
// .login-footer-container{
//   font-size: 3.7333rem;
// }
// .getcode-button {
//   position: absolute;
//   right: 0;
//   top: 0;
//   white-space: nowrap;
//   height: 10.6667rem;
//   line-height: 100%;
//   cursor: pointer;
//   border: none;
//   border-radius: 0 1.0667rem 1.0667rem 0;
//   // padding: 16px 27px;
//   box-sizing: border-box;
//   outline: 0;
//   transition: 0.1s;
//   font-weight: 500;
//   background-color: #0069EA;
//   color: #fff;
//   width: 25.0667rem;
//   font-size: 3.7333rem;
// }
// }
</style>
